// import React from "react";

// export const MobileResponsive = () => {
//   return (
//     <div className="relative lg:hidden flex items-center justify-center h-screen px-10 text-[#0f0f0f] bg-white">
//       <p className="text-center text-lg font-semibold leading-9">
//         Only within the limitless and enigmatic clarity of a desktop screen can
//         the true brilliance of this website’s design unveil its hidden depths,
//         beckoning those with the courage to uncover its mysteries. <br /> <br />
//         <i>~ Kuvaka Tech</i>
//       </p>
//       <img
//         src="/assets/illus1.svg"
//         className="w-full absolute bottom-0 -z-20"
//         alt=""
//       />
//     </div>
//   );
// };

import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const professionalMessages = [
  "This website is optimized for use on larger screens.",
  "For the best experience, please access this site on a compatible device.",
  "Your current device does not meet the requirements to view this content.",
  "Please switch to a device with a larger display to access this website.",
  "This site is designed for larger screens. Kindly use a supported device.",
  "We recommend accessing this page from a device with a larger display for full functionality.",
  "The current device is not compatible. Please use a device with a larger screen.",
  "For proper viewing and functionality, this page requires a device with a larger display.",
];

export const MobileResponsive = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const updateMessage = () => {
      setMessage(
        professionalMessages[
          Math.floor(Math.random() * professionalMessages.length)
        ]
      );
    };

    updateMessage();
    const interval = setInterval(updateMessage, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative lg:hidden flex justify-center items-center h-screen">
      <motion.div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="bg-not-found"
      >
        <motion.p
          className="text-center text-lg font-semibold leading-9 w-[90%]"
          key={message}
          initial={{ opacity: 0, y: 20 }}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.7,
              delay: 0.3,
              ease: [0.42, 0, 0.58, 1],
            },
          }}
        >
          {message}
        </motion.p>
      </motion.div>
    </div>
  );
};
